module.exports = __webpack_public_path__ + "img/branding&Design.38c8af59.png";